import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import SearchScenarioId from "owa-search-store/lib/store/schema/SearchScenarioId";
import { SearchTab } from "owa-search-types/lib/types/SearchTab";
import isTabEnabled from "./isTabEnabled";

export default function getVisibleScopeTabs(scenarioId: SearchScenarioId, mailboxInfo: MailboxInfo): SearchTab[] {
    if (scenarioId === SearchScenarioId.Calendar &&
        isGlobalFeatureEnabled("cal-sea-event-suggestion")) {
        return [
            SearchTab.All,
            SearchTab.Events,
            SearchTab.Mail,
            SearchTab.People,
            ...(isTabEnabled(SearchTab.Files, mailboxInfo, true) ? [SearchTab.Files] : []),
        ];
    }
    
    return [
        ...(isTabEnabled(SearchTab.All, mailboxInfo) ? [SearchTab.All] : []),
        SearchTab.Mail,
        ...(isTabEnabled(SearchTab.Events, mailboxInfo, scenarioId === SearchScenarioId.Mail)
            ? [SearchTab.Events]
            : []),
        ...(isTabEnabled(SearchTab.People, mailboxInfo, true) ? [SearchTab.People] : []),
        ...(isTabEnabled(SearchTab.Files, mailboxInfo, true) ? [SearchTab.Files] : []),
    ];
}
